// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_9e-3";
export var contentContainer = "_9e-0";
export var editorContainer = "_9e-1";
export var quillInputForm = "_9e-2";
export var zoneDivider = "_9e-4";